class sidebarFiltersForm extends HTMLElement {
    constructor() {
        super();
        this.onActiveFilterClick = this.onActiveFilterClick.bind(this);
        this.addEventListener('click', (event) => {
            const button = event.target.closest('[data-canvoil-columns]');
            if (!button || !this.contains(button)) return;
            this.querySelectorAll('[data-canvoil-columns]').forEach(item => item.setAttribute('aria-pressed', String(item === button)));
            sidebarFiltersForm.applyGridColumns();
        });


        this.debouncedOnSubmit = debounce((event) => {
            this.onSubmitHandler(event);
        }, 500);
        
        if(this.querySelector('form')){
            const form = this.querySelector('form');
            if (form.id === 'canvoilMobileSortForm') {
                form.addEventListener('change', () => {
                    const query = new URLSearchParams(window.location.search);
                    query.set('sort_by', form.querySelector('select').value);
                    query.delete('page');
                    window.location.assign(window.location.pathname + '?' + query.toString() + '#ProductGridContainer');
                });
            } else if (form.id === 'sidebarFiltersFormMobile') {
                form.addEventListener('input', () => {
                    this.updateMobilePriceBounds(form);
                    this.updateMobileDraft(form);
                });
                form.addEventListener('invalid', (event) => {
                    if (!event.target.matches('[data-canvoil-price-input]')) return;
                    const group = event.target.closest('details');
                    if (group) {
                        group.open = true;
                        group.querySelector('summary')?.setAttribute('aria-expanded', 'true');
                    }
                }, true);
                form.addEventListener('submit', (event) => {
                    event.preventDefault();
                    const priceInputs = form.querySelectorAll('[data-canvoil-price-input]');
                    if (priceInputs.length) {
                        this.updateMobilePriceBounds(form);
                        if (!form.reportValidity()) return;
                    }
                    const query = new URLSearchParams(new FormData(form));
                    form.querySelectorAll('input[type="range"]').forEach(input => {
                        const bound = input.name.endsWith('.gte') ? input.min : input.max;
                        if (Number(input.value) === Number(bound)) query.delete(input.name);
                    });
                    priceInputs.forEach(input => {
                        const bound = input.dataset.canvoilPriceInput === 'min' ? 0 : Number(input.dataset.priceMaximum);
                        if (input.value === '' || input.valueAsNumber === bound) query.delete(input.name);
                        else query.set(input.name, String(input.valueAsNumber));
                    });
                    form.querySelectorAll('[data-filter-apply]').forEach(button => {
                        if (!button.hasAttribute('data-canvoil-apply-label')) {
                            button.dataset.canvoilApplyLabel = button.textContent;
                            button.dataset.canvoilApplyDisabled = String(button.disabled);
                        }
                        button.disabled = true;
                        button.textContent = window.canvoilStrings?.filterApplying || 'Applying…';
                    });
                    const searchParams = sidebarFiltersForm.preserveAttributionParams(query);
                    window.location.assign(window.location.pathname + (searchParams ? '?' + searchParams : '') + '#ProductGridContainer');
                });
                form.querySelector('[data-filter-clear]')?.addEventListener('click', () => {
                    form.querySelectorAll('input[type="checkbox"]').forEach(input => { input.checked = false; });
                    form.querySelectorAll('input[type="range"]').forEach(input => {
                        input.value = input.name.endsWith('.gte') ? input.min : input.max;
                        input.dispatchEvent(new Event('input', { bubbles: true }));
                    });
                    form.querySelectorAll('[data-canvoil-price-input]').forEach(input => { input.value = ''; });
                    this.updateMobilePriceBounds(form);
                    this.updateMobileDraft(form);
                });
                this.updateMobilePriceBounds(form);
                this.updateMobileDraft(form);
            } else {
                form.addEventListener('input', this.debouncedOnSubmit.bind(this));
            }
        }
        const sidebarWrapper = this.querySelector('#sidebarWrapperDesktop');
        if (sidebarWrapper) sidebarWrapper.addEventListener('keyup', onKeyUpEscape);
    }

    updateMobilePriceBounds(form) {
        form.querySelectorAll('[data-canvoil-price-fields]').forEach(group => {
            const minimum = group.querySelector('[data-canvoil-price-input="min"]');
            const maximum = group.querySelector('[data-canvoil-price-input="max"]');
            if (!minimum || !maximum) return;
            const ceiling = Number(maximum.dataset.priceMaximum);
            if (!Number.isFinite(ceiling) || ceiling < 0) return;
            const minValue = minimum.valueAsNumber;
            const maxValue = maximum.valueAsNumber;
            minimum.min = '0';
            minimum.max = String(Number.isFinite(maxValue) && maxValue >= 0 && maxValue <= ceiling ? maxValue : ceiling);
            maximum.min = String(Number.isFinite(minValue) && minValue >= 0 && minValue <= ceiling ? minValue : 0);
            maximum.max = String(ceiling);
        });
    }

    updateMobileDraft(form) {
        form.querySelectorAll('.mobile-sidebar__details').forEach(group => {
            let note = group.querySelector('[data-filter-selection]');
            if (!note) {
                note = document.createElement('span');
                note.dataset.filterSelection = '';
                group.querySelector('summary > div').insertBefore(note, group.querySelector('.mobile-sidebar__arrow'));
            }
            const selected = group.querySelectorAll('input[type="checkbox"]:checked');
            note.textContent = selected.length ? String(selected.length) : '';
        });
    }

    static setListeners() {
        window.addEventListener('pageshow', (event) => {
            if (!event.persisted) return;
            document.querySelectorAll('#sidebarFiltersFormMobile [data-canvoil-apply-label]').forEach(button => {
                button.textContent = button.dataset.canvoilApplyLabel;
                button.disabled = button.dataset.canvoilApplyDisabled === 'true';
                delete button.dataset.canvoilApplyLabel;
                delete button.dataset.canvoilApplyDisabled;
            });
        });
        const onHistoryChange = (event) => {
            // Other same-page features may also write history state. The URL is authoritative.
            const searchParams = window.location.search.slice(1);
            if (searchParams === sidebarFiltersForm.searchParamsPrev && !sidebarFiltersForm.activeRequest &&
                !document.getElementById('CanvoilFilterError')) return;
            sidebarFiltersForm.renderPage(searchParams, null, false);
        }
        window.addEventListener('popstate', onHistoryChange);
    }

    static toggleActivesidebar(disable = true) {
        document.querySelectorAll('.js-sidebar-remove').forEach((element) => {
            element.classList.toggle('disabled', disable);
        });
    }

    static async renderPage(searchParams, event, updateURLHash = true) {
        searchParams = sidebarFiltersForm.preserveAttributionParams(searchParams);
        const requestId = ++sidebarFiltersForm.renderRequestId;
        sidebarFiltersForm.activeRequest?.abort();
        const controller = new AbortController();
        sidebarFiltersForm.activeRequest = controller;
        let timeout;
        let onAbort;
        sidebarFiltersForm.clearError();
        sidebarFiltersForm.setLoading(true);

        try {
            const sections = sidebarFiltersForm.getSections();
            const aborted = new Promise((resolve, reject) => {
                onAbort = () => reject(new Error('Filter request cancelled or timed out'));
                controller.signal.addEventListener('abort', onAbort, { once: true });
            });
            timeout = setTimeout(() => controller.abort(), sidebarFiltersForm.requestTimeout);
            const renders = sections.map(async (section) => {
                const url = `${window.location.pathname}?section_id=${encodeURIComponent(section.section)}&${searchParams}`;
                const filterDataUrl = element => element.url === url;
                return sidebarFiltersForm.filterData.some(filterDataUrl) ?
                    sidebarFiltersForm.renderSectionFromCache(filterDataUrl) :
                    sidebarFiltersForm.renderSectionFromFetch(url, controller.signal);
            });
            // Fetch and validate every section before changing any live markup or history.
            const results = await Promise.race([Promise.all(renders), aborted]);
            if (requestId !== sidebarFiltersForm.renderRequestId || controller.signal.aborted) return false;
            results.forEach(result => {
                try {
                    sidebarFiltersForm.validateSection(result.html);
                } catch (error) {
                    sidebarFiltersForm.filterData = sidebarFiltersForm.filterData.filter(entry => entry.url !== result.url);
                    throw error;
                }
            });
            const rollback = sidebarFiltersForm.captureRenderState();
            try {
                results.forEach(result => sidebarFiltersForm.renderSection(result.html, event, requestId));
                if (updateURLHash && window.location.search.slice(1) !== searchParams) {
                    sidebarFiltersForm.updateURLHash(searchParams);
                }
            } catch (error) {
                rollback();
                throw error;
            }
            sidebarFiltersForm.searchParamsPrev = searchParams;
            results.forEach(({ html, url }) => {
                sidebarFiltersForm.filterData = sidebarFiltersForm.filterData.filter(entry => entry.url !== url);
                sidebarFiltersForm.filterData.push({ html, url });
            });
            return true;
        } catch (error) {
            if (requestId !== sidebarFiltersForm.renderRequestId) return false;
            controller.abort();
            sidebarFiltersForm.showError(searchParams, updateURLHash);
            return false;
        } finally {
            clearTimeout(timeout);
            if (onAbort) controller.signal.removeEventListener('abort', onAbort);
            if (requestId === sidebarFiltersForm.renderRequestId) {
                sidebarFiltersForm.activeRequest = null;
                sidebarFiltersForm.setLoading(false);
                sidebarFiltersForm.toggleActivesidebar(false);
            }
        }
    }

    static clearError() {
        document.getElementById('CanvoilFilterError')?.remove();
        const grid = document.getElementById('ProductGridContainer');
        if (grid && sidebarFiltersForm.hiddenGrid === grid) {
            grid.hidden = sidebarFiltersForm.gridWasHidden;
            grid.style.display = sidebarFiltersForm.gridDisplay;
            sidebarFiltersForm.hiddenGrid = null;
        }
    }

    static showError(searchParams, updateURLHash) {
        const grid = document.getElementById('ProductGridContainer');
        if (!grid) return;
        sidebarFiltersForm.clearError();
        const notice = document.createElement('div');
        notice.id = 'CanvoilFilterError';
        notice.className = 'canvoil-filter-error';
        notice.setAttribute('role', 'alert');
        notice.setAttribute('tabindex', '-1');
        notice.style.cssText = 'padding:1.5rem 0;grid-column:1 / -1;';
        const message = document.createElement('p');
        message.textContent = window.canvoilStrings?.filterError || 'We couldn’t update the results. Please try again.';
        const retry = document.createElement('button');
        retry.type = 'button';
        retry.className = 'button button--primary-outline';
        retry.textContent = window.canvoilStrings?.filterRetry || 'Try again';
        retry.addEventListener('click', () => sidebarFiltersForm.renderPage(searchParams, null, updateURLHash));
        notice.append(message, retry);
        grid.before(notice);
        // On a failed Back/Forward request the address has already changed. Never show
        // products belonging to the previous address as if they were the requested result.
        sidebarFiltersForm.hiddenGrid = grid;
        sidebarFiltersForm.gridWasHidden = grid.hidden;
        sidebarFiltersForm.gridDisplay = grid.style.display;
        grid.hidden = true;
        grid.style.display = 'none';
        notice.focus({ preventScroll: true });
    }

    static validateSection(html) {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        if (!parsed.getElementById('ProductGridContainer') || !parsed.getElementById('product-grid')) {
            throw new Error('Incomplete filter response');
        }
        if ((document.getElementById('ProductCount') || document.getElementById('ProductCountDesktop')) &&
            !parsed.getElementById('ProductCount') && !parsed.getElementById('ProductCountDesktop')) {
            throw new Error('Missing filter count');
        }
        ['sidebarFiltersForm', 'sidebarFiltersFormMobile', 'canvoilMobileSortForm'].forEach(id => {
            if (document.getElementById(id) && !parsed.getElementById(id)) throw new Error('Missing filter controls');
        });
    }

    static captureRenderState() {
        const selectors = '#ProductGridContainer, #main-collection-filters, .canvoil-collection-toolbar, .js-filter, .active-sidebar-mobile, .active-sidebar-desktop, .mobile-sidebar__open, .mobile-sidebar__count, .sorting, #canvoilMobileSortForm, #ProductCount, #ProductCountDesktop';
        const nodes = Array.from(document.querySelectorAll(selectors));
        const states = nodes.filter(node => !nodes.some(parent => parent !== node && parent.contains(node))).map(node => ({
            node,
            html: node.innerHTML,
            controls: Array.from(node.querySelectorAll('input, select')).map(control => ({ value: control.value, checked: control.checked }))
        }));
        return () => states.forEach(({ node, html, controls }) => {
            node.innerHTML = html;
            node.querySelectorAll('input, select').forEach((control, index) => {
                if (!controls[index]) return;
                control.value = controls[index].value;
                if ('checked' in control) control.checked = controls[index].checked;
            });
        });
    }

    static setLoading(loading) {
        const grid = document.getElementById('ProductGridContainer');
        grid?.setAttribute('aria-busy', String(loading));
        grid?.querySelector('.collection')?.classList.toggle('loading', loading);
        ['ProductCount', 'ProductCountDesktop'].forEach(id => {
            document.getElementById(id)?.classList.toggle('loading', loading);
        });
    }

    static renderSectionFromFetch(url, signal) {
        return fetch(url, { signal })
            .then(response => {
                if (!response.ok) throw new Error(`Filter request failed: ${response.status}`);
                return response.text();
            })
            .then(html => ({ html, url }));
    }

    static renderSectionFromCache(filterDataUrl) {
        return Promise.resolve(sidebarFiltersForm.filterData.find(filterDataUrl));
    }

    static renderSection(html, event, requestId) {
        // A page request owns every section, including cache hits, until a newer request starts.
        if (requestId !== sidebarFiltersForm.renderRequestId) return;
        sidebarFiltersForm.renderFilters(html, event);
        sidebarFiltersForm.renderProductGridContainer(html);
        sidebarFiltersForm.renderProductCount(html);
        sidebarFiltersForm.setLoading(true);
    }

    static applyGridColumns() {
        const selected = document.querySelector('[data-canvoil-columns][aria-pressed="true"]');
        const grid = document.getElementById('product-grid');
        if (!selected || !grid) return;
        const columns = selected.dataset.canvoilColumns;
        if (!['3', '4'].includes(columns)) return;
        grid.classList.remove('grid--2-col-desktop', 'grid--3-col-desktop', 'grid--4-col-desktop');
        grid.classList.add(`grid--${columns}-col-desktop`);
    }

    static renderProductGridContainer(html) {
        document.getElementById('ProductGridContainer').innerHTML = new DOMParser().parseFromString(html, 'text/html').getElementById('ProductGridContainer').innerHTML;
        sidebarFiltersForm.applyGridColumns();
    }

    static renderProductCount(html) {
        const parsed = new DOMParser().parseFromString(html, 'text/html');
        const source = parsed.getElementById('ProductCount') || parsed.getElementById('ProductCountDesktop');
        if (!source) return;
        const count = source.innerHTML;
        const container = document.getElementById('ProductCount');
        const containerDesktop = document.getElementById('ProductCountDesktop');
        if (container) {
            container.innerHTML = count;
            container.classList.remove('loading');
        }
        if (containerDesktop) {
            containerDesktop.innerHTML = count;
            containerDesktop.classList.remove('loading');
        }
    }

    static renderFilters(html, event) {
        const parsedHTML = new DOMParser().parseFromString(html, 'text/html');

        const sidebarDetailsElements =
            parsedHTML.querySelectorAll('#sidebarFiltersForm .js-filter, #sidebarFiltersFormMobile .js-filter');
        const matchesIndex = (element) => {
            const jsFilter = event ? event.target.closest('.js-filter') : undefined;
            return jsFilter ? element.dataset.index === jsFilter.dataset.index : false;
        }
        const sidebarToRender = Array.from(sidebarDetailsElements).filter(element => !matchesIndex(element));
        const countsToRender = Array.from(sidebarDetailsElements).find(matchesIndex);

        sidebarToRender.forEach((element) => {
            const target = document.querySelector(`.js-filter[data-index="${element.dataset.index}"]`);
            if (target) {
                target.innerHTML = element.innerHTML;
                if (element.querySelector('[data-canvoil-price-fields]')) target.open = element.open;
            }
        });

        sidebarFiltersForm.renderActivesidebar(parsedHTML);
        sidebarFiltersForm.renderAdditionalElements(parsedHTML);

        if (countsToRender) sidebarFiltersForm.renderCounts(countsToRender, event.target.closest('.js-filter'));
    }

    static renderActivesidebar(html) {
        const activesidebarElementSelectors = ['.active-sidebar-mobile', '.active-sidebar-desktop'];

        activesidebarElementSelectors.forEach((selector) => {
            const activesidebarElement = html.querySelector(selector);
            if (!activesidebarElement) return;
            const target = document.querySelector(selector);
            if (target) target.innerHTML = activesidebarElement.innerHTML;
        })

        sidebarFiltersForm.toggleActivesidebar(false);
    }

    static renderAdditionalElements(html) {
        const mobileElementSelectors = ['.mobile-sidebar__open', '.mobile-sidebar__count', '.sorting'];

        mobileElementSelectors.forEach((selector) => {
            const source = html.querySelector(selector);
            const target = document.querySelector(selector);
            if (source && target) target.innerHTML = source.innerHTML;
        });

        const mobileFilters = document.getElementById('sidebarFiltersFormMobile');
        const sourceMobileFilters = html.getElementById('sidebarFiltersFormMobile');
        const selectedSort = sourceMobileFilters?.querySelector('[name="sort_by"]')?.value
            ?? html.querySelector('#canvoilMobileSortForm select[name="sort_by"]')?.value;
        if (selectedSort !== undefined) {
            mobileFilters?.querySelectorAll('[name="sort_by"]').forEach(input => {
                input.value = selectedSort;
                input.setAttribute('value', selectedSort);
            });
        }

        const mobileSortForm = document.getElementById('canvoilMobileSortForm');
        const sourceMobileSortForm = html.getElementById('canvoilMobileSortForm');
        if (mobileSortForm && sourceMobileSortForm) {
            // Keep the form itself: its change listener also preserves the current attribution query.
            mobileSortForm.innerHTML = sourceMobileSortForm.innerHTML;
            const select = mobileSortForm.querySelector('select[name="sort_by"]');
            if (select && selectedSort !== undefined) {
                select.value = selectedSort;
                mobileSortForm.querySelectorAll('[data-canvoil-sort]').forEach(button => {
                    button.setAttribute('aria-pressed', String(button.dataset.canvoilSort === selectedSort));
                });
                const label = mobileSortForm.querySelector('.canvoil-sort-value');
                if (label && select.selectedOptions[0]) label.textContent = select.selectedOptions[0].textContent;
            }
        }

        mobileFilters?.closest('menu-drawer')?.bindEvents();
    }

    static renderCounts(source, target) {
        const targetElement = target.querySelector('.sidebar__selected');
        const sourceElement = source.querySelector('.sidebar__selected');

        if (sourceElement && targetElement) {
            target.querySelector('.sidebar__selected').outerHTML = source.querySelector('.sidebar__selected').outerHTML;
        }
    }

    static preserveAttributionParams(searchParams) {
        const query = new URLSearchParams(searchParams);
        const current = new URLSearchParams(window.location.search);
        for (const key of new Set(current.keys())) {
            if (/^(utm_.+|fbclid|gclid|dclid|gbraid|wbraid|msclkid|ttclid|srsltid)$/i.test(key) && !query.has(key)) {
                current.getAll(key).forEach(value => query.append(key, value));
            }
        }
        return query.toString();
    }

    static updateURLHash(searchParams) {
        history.pushState({ ...history.state, searchParams }, '', `${window.location.pathname}${searchParams && '?'.concat(searchParams)}${window.location.hash}`);
    }

    static getSections() {
        return [{
            section: document.getElementById('product-grid').dataset.id,
        }]
    }

    onSubmitHandler(event) {
        event.preventDefault();
        const form = event.target.closest('form');
        const desktopFilters = document.getElementById('sidebarFiltersForm');
        const desktopSort = document.getElementById('CanvoilSortBy');
        const isDesktop = desktopSort && (form.id === 'canvoilSortForm' || form.id === 'sidebarFiltersForm');
        const mobileFilters = document.getElementById('sidebarFiltersFormMobile');
        const filtersForSort = form.id === 'canvoilSortForm' && window.matchMedia('(max-width: 749px)').matches ? mobileFilters : desktopFilters;
        const formData = new FormData(isDesktop && filtersForSort ? filtersForSort : form);
        if (isDesktop) formData.set('sort_by', desktopSort.value);
        const searchParams = new URLSearchParams(formData).toString();
        sidebarFiltersForm.renderPage(searchParams, event);
    }

    onActiveFilterClick(event) {
        event.preventDefault();
        sidebarFiltersForm.toggleActivesidebar();
        const url = event.currentTarget.href.indexOf('?') == -1 ? '' : event.currentTarget.href.slice(event.currentTarget.href.indexOf('?') + 1);
        sidebarFiltersForm.renderPage(url);
    }
}

sidebarFiltersForm.filterData = [];
sidebarFiltersForm.renderRequestId = 0;
sidebarFiltersForm.requestTimeout = 15000;
sidebarFiltersForm.activeRequest = null;
sidebarFiltersForm.searchParamsInitial = window.location.search.slice(1);
sidebarFiltersForm.searchParamsPrev = window.location.search.slice(1);
customElements.define('sidebar-filters-form', sidebarFiltersForm);
sidebarFiltersForm.setListeners();

class PriceRange extends HTMLElement {
    constructor() {
        super();
        this.querySelectorAll('input').forEach(element => element.addEventListener('input', this.onRangeChange.bind(this)));
    }

    onRangeChange(event) {
        function handleRangeElements(className, idName) {
          if (document.querySelector(className)) {
            let val = document.querySelector(className).value;
            document.getElementById(idName).innerHTML = val;
    
            document.querySelector(className).addEventListener('change', function() {
              let val = this.value;
              document.getElementById(idName).innerHTML = val;
            });
          }
        }
        
        handleRangeElements('.range_from2', 'range_from2');
        handleRangeElements('.range_from', 'range_from');
        
        handleRangeElements('.mobilerange_from2', 'mobilerange_from2');
        handleRangeElements('.mobilerange_from', 'mobilerange_from');   
    }
}

customElements.define('price-range', PriceRange);

class sidebarRemove extends HTMLElement {
    constructor() {
        super();
        this.querySelector('a').addEventListener('click', (event) => {
            event.preventDefault();
            const form = this.closest('sidebar-filters-form') || document.querySelector('sidebar-filters-form');
            form.onActiveFilterClick(event);
        });
    }
}

customElements.define('sidebar-remove', sidebarRemove);
